import type { AnchorHTMLAttributes, CSSProperties, ElementType, FC } from 'react'
import { forwardRef } from 'react'
import styles from './link.module.css'

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  color?: 'primary' | 'secondary' | 'inherit' | (string & {})
  underline?: 'always' | 'hover' | 'none'
  component?: ElementType
}

const colorMap: Record<string, string> = {
  primary: 'var(--tuna-palette-primary-main)',
  secondary: 'var(--tuna-palette-secondary-main)',
  inherit: 'inherit',
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ color = 'primary', underline = 'always', component: Tag = 'a', className, style, ...rest }, ref) => {
    const classes = [
      styles.link,
      underline === 'hover' ? styles.underlineHover : undefined,
      className,
    ]
      .filter(Boolean)
      .join(' ')

    const computedStyle: CSSProperties = {
      color: colorMap[color] ?? color,
      textDecoration: underline === 'always' ? 'underline' : 'none',
      cursor: 'pointer',
      ...style,
    }

    // Cast needed: Tag is ElementType (string | ComponentType) which TS can't narrow for JSX
    const Component = Tag as FC<Record<string, unknown>>
    return <Component ref={ref} className={classes} style={computedStyle} {...rest} />
  }
)

Link.displayName = 'Link'
